import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { apiFetch } from '../api/api';

export class NavMenu extends Component<{ isAuthenticated: boolean; }, { collapsed: boolean; }> {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">PlantBoard.Admin</NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/">Boards</NavLink>
                                </NavItem>
                                {this.props.isAuthenticated && <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="#" onClick={async e => {
                                        e.preventDefault();
                                        apiFetch("/Account/Logout", { method: "POST" });
                                        window.location.href = "/Account/Login?returnUrl=" + encodeURIComponent("/");
                                    }}>Logout</NavLink>
                                </NavItem>}
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
